import { render, staticRenderFns } from "./fpzliabilityDetail.vue?vue&type=template&id=3fc494db"
import script from "./fpzliabilityDetail.vue?vue&type=script&lang=js"
export * from "./fpzliabilityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports